import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuditResultDetail } from 'src/app/core-module/models/Audits/AuditResults/audit-result-detail';
import { UtilService } from 'src/app/core-module/services/util.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-audit-result-detail',
    templateUrl: './audit-result-detail.component.html',
    styleUrl: './audit-result-detail.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuditResultDetailComponent {
  @Input() auditResultDetail:AuditResultDetail = new AuditResultDetail();
  @Input() eventId: number = -1;
  @Input() showQuestionsAccordion: boolean = false;

  public isBluebird:boolean = false;
  public questionsCollapsed: boolean = true;

  constructor(private utilService:UtilService){
    this.isBluebird = environment.blueBird;
  }

  calcPercent():number{
    return this.utilService.calcPercentage(this.auditResultDetail.Score,this.auditResultDetail.MaxScore);
  }

  showScore(): boolean {
    return this.eventId < 0 && !this.auditResultDetail.HideScore;
  }

  humanDate(date:Date){
    return this.utilService.humanDate(date);
  }

  overdueActions():number{
    return Math.max(0,this.auditResultDetail.TotalOverdueActions);
  }

  statusBorderClass(): string {
    if (this.auditResultDetail.TotalOverdueActions > 0) {
      return 'border-danger-base';
    }

    if (this.auditResultDetail.TotalOutstandingActions > 0) {
      return 'border-warning-base';
    }

    return '';
  }

  toggleQuestions(){
    this.questionsCollapsed = !this.questionsCollapsed;
  }

}
